import {
  CartDigitalData,
  DigitalData,
  PageDigitalData,
  PaymentInfoDigitalData,
  PaymentSuccessDigitalData,
  ProductDigitalData,
  RadUiVersion,
  UserDigitalData,
  VehicleDigitalData,
} from './digitalData'

const loggedOutUser: UserDigitalData = {
  loginStatus: 'logged out',
}

const emptyVehicleData: VehicleDigitalData = {
  price: '',
}

const emptyProductInfoObject: ProductDigitalData = {
  SKU: '',
  name: '',
  category: '',
  subCategory: '',
  nameplate: '',
  modelYear: '',
  quantity: '',
  unitPrice: '',
  unitPriceDiscounted: '',
  unitDiscountAmount: '',
  totalInstallationCost: '',
  totalCost: '',
  installationType: '',
  availability: '',
  discountCode: '',
}

function buildCart(orderNumber: string = ''): CartDigitalData {
  return {
    orderNumber: orderNumber,
    subTotalNoDiscount: '',
    subTotal: '',
    discountAmount: '',
    shippingCost: '',
    taxes: '',
    cartTotal: '',
    discountCode: '',
    deliveryMethod: '',
    productInfo: [emptyProductInfoObject],
  }
}

function buildPageDigitalData(
  pageName: string,
  tool?: string,
  toolDescriptor?: string,
  hierarchy: string = pageName,
  radUiVersion: RadUiVersion = 'ui:rad:{pc|tablet|mobile}',
): PageDigitalData {
  const pageDigitalData: PageDigitalData = {
    pageName: pageName,
    siteSection: 'ecom',
    hierarchy: hierarchy,
    userLanguage: 'eng',
    pageNameNoVehicle: hierarchy,
    client: 'fpro-us',
    site: 'pro.ford.com',
    radUIVersion: radUiVersion,
  }
  if (tool) {
    pageDigitalData.tool = tool
  }
  if (toolDescriptor) {
    pageDigitalData.toolDescriptor = toolDescriptor
  }
  return pageDigitalData
}

export const cartViewDigitalData: DigitalData = {
  page: buildPageDigitalData('fpro:ecom:cart view', 'event:cart view'),
  user: loggedOutUser,
  event: {
    action: 'tool,scView,scOpen',
  },
  cart: buildCart(),
}

export const removeDigitalData: DigitalData = {
  page: buildPageDigitalData(
    '',
    'event:cart remove',
    'cart remove:ecom',
    'fpro:ecom:cart view',
  ),
  user: loggedOutUser,
  vehicle: {
    optionsPicked: '',
    price: '',
  },
  onclick: {
    onclickLinkName: 'fpro:ecom:cart view:content action',
    onclick: 'ecom:cart view:remove',
  },
  event: {
    action: 'tool,scRemove',
  },
  cart: buildCart(),
}

export const quantityDigitalData: DigitalData = {
  page: buildPageDigitalData(
    '',
    'event:cart quantity',
    undefined,
    'fpro:ecom:cart view',
  ),
  user: loggedOutUser,
  onclick: {
    onclickLinkName: 'fpro:ecom:cart view:content action',
    onclick: 'ecom:cart view:quantity update',
  },
  event: {
    action: 'tool,quantity update',
  },
}

export const cartEmptyDigitalData: DigitalData = {
  page: buildPageDigitalData('fpro:ecom:cart empty', 'event:cart empty'),
  user: loggedOutUser,
  vehicle: emptyVehicleData,
  event: {
    action: 'tool',
  },
  cart: {
    subTotal: 'ecom:cart empty page',
    cartTotal: 'ecom:cart empty page',
  },
}

export const userInfoDigitalData: DigitalData = {
  page: buildPageDigitalData(
    'fpro:ecom:checkout:1 user info',
    'event:cart checkout',
    'cart checkout:1 user info:ecom',
  ),
  user: loggedOutUser,
  vehicle: emptyVehicleData,
  event: {
    action: 'tool,lead start,scCheckout,checkout-1 ',
  },
  cart: buildCart(),
}

export function buildPaymentInfoDigitalData(
  orderNumber: string,
): PaymentInfoDigitalData {
  return {
    page: buildPageDigitalData(
      'fpro:ecom:checkout:2 payment info',
      'event:cart checkout',
      'cart checkout:2 payment info:ecom',
    ),
    user: loggedOutUser,
    vehicle: emptyVehicleData,
    event: {
      action: 'tool,checkout-2',
    },
    cart: buildCart(orderNumber),
  }
}

export function buildPaymentSuccessDigitalData(
  orderNumber: string,
): PaymentSuccessDigitalData {
  return {
    page: buildPageDigitalData(
      'fpro:ecom:checkout:3 purchase',
      'event:cart purchase',
      'cart purchase:ecom',
    ),
    user: {
      leadType: 'purchase:ecom',
      leadOptIn: 'purchase:ecom',
      loginStatus: 'logged out',
    },
    vehicle: emptyVehicleData,
    purchase: {
      purchaseID: orderNumber,
      transactionID: orderNumber,
    },
    event: {
      action: 'lead submitted,updates opt-in,tool,purchase',
    },
    cart: buildCart(orderNumber),
  }
}
